import { Logger } from "./logger";

export type WsAchieveResponse = {
	type: string;
	success: boolean;
	message: string;
	achievement_id: number | string;
};

export const handleWsAchieveResponse = (
	response: WsAchieveResponse,
	achieveCb: (id: number) => void,
) => {
	let { achievement_id } = response;
	const { success } = response;

	if (typeof achievement_id !== "number") {
		achievement_id = parseInt(achievement_id);
	}

	let pendingAchievementsStr = "[]";
	let pendingAchievements: any[] = [];
	try {
		pendingAchievementsStr = decodeURIComponent(
			localStorage.getItem("pendingAchievements") || "[]",
		);
		pendingAchievements = JSON.parse(pendingAchievementsStr);
	} catch (e) {
		Logger.log("Error parsing pending achievements", e);
		pendingAchievements = [];
		pendingAchievementsStr = "[]";
	}

	const achievementIndex = pendingAchievements.indexOf(achievement_id);
	if (achievementIndex > -1) {
		pendingAchievements.splice(achievementIndex, 1);
	}

	pendingAchievementsStr = JSON.stringify(pendingAchievements);
	localStorage.setItem(
		"pendingAchievements",
		encodeURIComponent(pendingAchievementsStr),
	);

	if (success) {
		achieveCb(achievement_id);
	}
};

export const sendPendingAchieves = (ws: WebSocket) => {
	let pendingAchievementsStr = "[]";
	let pendingAchievements: any[] = [];
	try {
		pendingAchievementsStr = decodeURIComponent(
			localStorage.getItem("pendingAchievements") || "[]",
		);
		pendingAchievements = JSON.parse(pendingAchievementsStr);
	} catch (e) {
		Logger.log("Error parsing pending achievements", e);
		pendingAchievements = [];
		pendingAchievementsStr = "[]";
	}

	pendingAchievements.forEach((id) => {
		ws.send(JSON.stringify({ type: "achieve", achievement_id: parseInt(id) }));
	});

	Logger.log("Sending pending achievements: " + pendingAchievements);
};

export const registerAchievementLocally = (achievementId: number) => {
	let pendingAchievementsStr = "[]";
	let pendingAchievements: any[] = [];
	try {
		pendingAchievementsStr = decodeURIComponent(localStorage.getItem("pendingAchievements") || "[]");
		pendingAchievements = JSON.parse(pendingAchievementsStr);

		if (!pendingAchievements.includes(achievementId)) {
			pendingAchievements.push(achievementId);
		}

	} catch (e) {
		Logger.log("Error parsing pending achievements", e);
		pendingAchievements = [];
		pendingAchievementsStr = "[]";
	}


	pendingAchievementsStr = JSON.stringify(pendingAchievements);
	localStorage.setItem("pendingAchievements", encodeURIComponent(pendingAchievementsStr));
}